import { render, staticRenderFns } from "./SyncSuppliersDialog.vue?vue&type=template&id=0264a8c7"
import script from "./SyncSuppliersDialog.vue?vue&type=script&lang=js"
export * from "./SyncSuppliersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports